import { Loader2 } from "lucide-react";
import { CardTitle, CardHeader } from "../../../shadcn/Card";
import { SearchNameInput } from "./SearchNameInput";

export interface MatchingResultsProps {
  title: string | React.ReactNode;
  creditCost: number;
  availableCredits: number | null;
  formattedCredits: string | undefined;
  isFetching?: boolean;
  searchName: string;
  onSearchNameChange: (value: string) => void;
  onSaveSearchClick: () => void;
  onClearSearchClick: () => void;
  isSaving?: boolean;
  autoFocusAndSelect?: boolean;
  autoFocusTrigger?: any;
}

export function MatchingResults({
  title,
  creditCost,
  availableCredits,
  formattedCredits,
  isFetching = false,
  searchName,
  onSearchNameChange,
  onSaveSearchClick,
  onClearSearchClick,
  isSaving = false,
  autoFocusAndSelect = false,
  autoFocusTrigger = null,
}: MatchingResultsProps) {
  return (
    <>
      <CardHeader className="py-3">
        <CardTitle className="text-center text-xl text-primary relative">
          {typeof title === 'string' ? (
            <div className="text-xl text-primary">{title}</div>
          ) : (
            title
          )}
          {isFetching && (
            <Loader2 className="absolute right-0 top-0 animate-spin h-5 w-5" />
          )}
        </CardTitle>
        <div className="text-sm text-gray-500 text-center">
          Save this search for{" "}
          <strong>
            {creditCost} credit{creditCost > 1 ? "s" : ""}
          </strong>
          {availableCredits !== null && (
            <div className="mt-1">
              Available credits: <strong>{formattedCredits}</strong>
            </div>
          )}
        </div>
      </CardHeader>

      <SearchNameInput
        searchName={searchName}
        onSearchNameChange={onSearchNameChange}
        onSaveSearchClick={onSaveSearchClick}
        onClearSearchClick={onClearSearchClick}
        isSaving={isSaving}
        autoFocusAndSelect={autoFocusAndSelect}
        autoFocusTrigger={autoFocusTrigger}
      />
    </>
  );
}